// extracted by mini-css-extract-plugin
export default {"melodyVideo":"rI-z","isFullWidth":"sI-z","landingPageVideo":"tI-z","play":"uI-z","iframeVideo":"vI-z","playHidden":"wI-z","fullwidth":"xI-z"};